import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Nav } from "@/components/Nav";
import { About } from "@/components/About";
import { Experience } from "@/components/Experience";
import { Projects } from "@/components/Projects";
import { Skills } from "@/components/Skills";
import { Education } from "@/components/Education";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const Portfolio = () => (
  <div className="grain relative min-h-screen text-white overflow-x-hidden">
    <Nav />
    <main className="relative z-[2]">
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Education />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
